import '../../style/base.css';
import '../../loading/index.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/list/style/index.js
// module id = 201
// module chunks = 7